import { Component, OnDestroy } from '@angular/core';
import { ESignatureSuccessHandlerService } from './core/services/e-signature-success-handler.service';
import { AuthService } from './core/services';
import { ThemeService } from './core/services/theme.service';
import { UIThemeType } from './shared/models';

@Component({
    selector: 'app-root',
    template: `@if (loggedIn) {
            <cl-header-motd-messages></cl-header-motd-messages>
        }
        <router-outlet></router-outlet>`,
    standalone: false,
})
export class AppComponent implements OnDestroy {
    get loggedIn(): boolean {
        return this.authService.loggedIn;
    }
    constructor(
        private eSignatureSeuccessHandler: ESignatureSuccessHandlerService,
        private authService: AuthService,
        private themeService: ThemeService,
    ) {
        this.eSignatureSeuccessHandler.init();
        const lastUsedTheme: number = parseInt(localStorage.getItem('uiTheme'), 10);
        this.themeService.switchTheme(lastUsedTheme ? lastUsedTheme : UIThemeType.Default);
    }

    ngOnDestroy(): void {
        this.eSignatureSeuccessHandler.disable();
    }
}
